import {
  BusinessVerificationLocationType,
  CompanyNPWPDocumentMetadata,
  VerificationMethod,
} from '../../../common/interfaces/entities';
export const VerifyWithProofPersonalDocumentType = {
  NPWP: 'NPWP',
  KTP: 'KTP',
} as const;

export type VerifyWithProofPersonalDocumentType =
  (typeof VerifyWithProofPersonalDocumentType)[keyof typeof VerifyWithProofPersonalDocumentType];

export type CompanyVerificationFormState = {
  verificationMethod: VerificationMethod;
  isViewOnly: boolean;
  verifyWithLegalDocuments: {
    companyNPWPDoc: string | null;
    companyNPWPNumber: string | null;
    companyNIBNumber: string | null;
    additionalDocuments: string[];
    companyNPWPDocMetadata?: CompanyNPWPDocumentMetadata;
    legalDocumentNotOfficial?: boolean;
    acraBizFile: string | null;
    companyUniqueEntityNumber: string | null;
    allowCompanyNameEdit: boolean;
    companyName: string;
    companyExistsError?: string;
    companyLegalDoc?: string;
    companyLegalNumber?: string;
  };
  verifyWithProofOfOwnership: {
    isWhatsAppVerified: boolean;
    personalDocumentType: VerifyWithProofPersonalDocumentType;
    personalNPWPDoc: string;
    personalNPWPNumber: string;
    ktpDoc: string;
    ktpNumber: string;
    personalNIBNumber: string;
    businessLocationType: BusinessVerificationLocationType;
    businessActivityImages: string[];
    additionalDocuments: string[];
  };
};

export type UpdateCompanyVerificationFormState = {
  companyName: string | null;
  companyUniqueEntityNumber: string | null;
};
